import script from "./CircleSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleSpinner.vue?vue&type=script&setup=true&lang=js"

import "./CircleSpinner.vue?vue&type=style&index=0&id=befd606c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-befd606c"]])

export default __exports__